<kf-loader>
  <div if="{ !props.hasOwnProperty('loader') || props.loader }" class="kf-loader">
    <div class="loader"></div>
  </div>
  <script>
    export default {
      onUpdated(props) {
        if (props.loader && document.activeElement && document.activeElement.blur) {
          document.activeElement.blur();
        }
      }
    };
  </script>
  <style type="postcss">
    .kf-loader {
      position: fixed;
      z-index: 19999;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      overflow: auto;
      background-color: rgba(0, 0, 0, 0.2);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .loader {
      display: inline-block;
      border: 7px solid #f3f3f3;
      border-top: 10px solid #661fff;
      border-radius: 50%;
      width: 100px;
      height: 100px;
      animation: spin 2s linear infinite;
      z-index: 9999;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  </style>
</kf-loader>